module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/1-b4a9ac03c6312c4b61bed414cb882a98.jpg";